import React, { useState, useEffect } from "react";
import imageCompression from "browser-image-compression";
import Layout from "../../components/Layout";
import "./GenerateQRCode.css";
import {
  Collapse,
  Form,
  Button,
  Space,
  Row,
  Col,
  Input,
  Upload,
  Modal,
  message,
  Radio,
  Slider,
  Image,
  Switch,
} from "antd";
import { useDebouncedCallback } from "use-debounce";

import {
  RiBehanceFill,
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiMailFill,
  RiMap2Fill,
  RiSkypeFill,
  RiTelegramFill,
  RiTwitterFill,
  RiWhatsappFill,
  RiYoutubeFill,
  RiSnapchatFill,
  RiExternalLinkFill,
} from "react-icons/ri";
import { CgColorPicker } from "react-icons/cg";
import { FaTiktok } from "react-icons/fa";
import {
  DoubleRightOutlined,
  PlusOutlined,
  LinkOutlined,
  DeleteOutlined,
  CopyOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import shortId from "shortid";
import getBase64 from "../../helpers/getBase64";
import { request } from "../../config/API";
import authHeader from "../../redux/services/authHeader";
import { COLORS } from "../../config/theme";
import QRCode from "../../components/QRCode";
import { API, Domain } from "../../config/API";
import PreviewVcard from "../../components/PreviewVcard";
import { SketchPicker } from "react-color";
import { Helmet } from "react-helmet";
import { openNotification } from "../../redux/actions/Notification/notifications.action";
import ImgCrop from "antd-img-crop";
import { Link } from "react-router-dom";
import { loader } from "../../assets/images";
import { useSelector } from "react-redux";
import LocationSearch from "../../components/LocationSearch";

const iconNames = require("../../helpers/ICONS.json");
let link = shortId();
const GenerateQRCode = () => {
  useEffect(() => {
    return (link = shortId());
  }, []);
  // const history = useHistory();
  // Failed Form Modal
  const { Search } = Input;
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const { primary, primaryDark, danger } = COLORS;
  const { subscribedPlan } = useSelector((state) => state.membership);
  const { role } = useSelector((state) => state.auth.user);
  const [sectionOrder, setSectionOrder] = useState([
    { key: "1", header: "Contact" },
    { key: "2", header: "Web Links" },
    { key: "3", header: "About Us" },
    { key: "4", header: "SCAN QR CODE" },
    { key: "5", header: "Gallery" },
    { key: "6", header: "Gallery" },
  ]);
  const { Item } = Form;
  const [form] = Form.useForm();
  const { Panel } = Collapse;
  const controller = new AbortController();
  const options = {
    signal: controller.signal,
    maxSizeMB: 1,
  };
  // colors
  // const [primaryColor, setPrimaryColor] = useState(primaryDark);
  // const [secondaryColor, setSecondaryColor] = useState(primary);
  const [colors, setColors] = useState({
    primary,
    secondary: primaryDark,
  });
  const [togglePicker, setTogglePicker] = useState(false);
  const [togglePicker1, setTogglePicker1] = useState(false);
  // Basic Info
  const [basicInfo, setBasicInfo] = useState({
    fName: "",
    lName: "",
    fNamePrefix: "",
    lNameSuffix: "",
    mobile: "",
    mobile2: "",
    email: "",
    email2: "",
    phone: "",
    phone2: "",
    company: "",
    address: "",
    postalAddress: "",
    summary: "",
    jobTitle: "",
  });
  const [locationInfo, setLocationInfo] = useState({});

  const handleBasicInfo = (e) => {
    setBasicInfo({ ...basicInfo, [e.target.name]: e.target.value });
  };

  // image upload loading
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  // image uploads

  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  // Image Upload

  const postImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("images", compressedFile);
        console.log({ compressedFile });
        console.log(
          "file size ",
          compressedFile.size / 1000,
          compressedFile.size / 1000 <= 1000
        );
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.images,
              status: "done",
              url: Domain + "/data/" + data.images,
            };
            setFileList([...fileList, newData]);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  // Social Links
  const [isFacebook, setIsFacebook] = useState(false);
  const [isInstagram, setIsInstagram] = useState(false);
  const [isLinkedin, setIsLinkedin] = useState(false);
  const [isTwitter, setIsTwitter] = useState(false);
  const [isSkype, setIsSkype] = useState(false);
  const [isBehance, setIsBehance] = useState(false);
  const [isYoutube, setIsYoutube] = useState(false);
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMail, setIsMail] = useState(false);
  const [isTelegram, setIsTelegram] = useState(false);
  const [isTiktok, setIsTiktok] = useState(false);
  const [isSnapchat, setIsSnapchat] = useState(false);

  // Add Qr
  const [isAdding, setIsAdding] = useState(false);
  const [isAddedSuccess, setIsAddedSuccess] = useState(false);
  const [showQr, setShowQr] = useState(false);

  const addQr = (d) => {
    setIsAdding(true);
    // console.log(d);
    // .post("https://wavecode-backend.herokuapp.com/api/qr", d, {
    request
      .post(API + "/qr", d, {
        headers: { ...authHeader() },
      })
      .then((data) => {
        setIsAdding(false);
        message.success("QR Added");
        // history.push("/app/my-wave-code");
      })
      .then(() => setIsAddedSuccess(true))
      .catch((err) => {
        openNotification({
          message: "Error",
          description: err?.response?.data?.data,
          icon: "error",
        });
        setIsAdding(false);
      });
  };

  // Download QR
  const handleDownloadQR = () => {
    const canvas = document.getElementById("react-qrcode-logo");
    const pngUrl = canvas
      ?.toDataURL("image/png")
      ?.replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = link + ".png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  const [youtubeLinks, setYoutubeLinks] = useState([]);
  const [iconModal, setIconModal] = useState("");
  const [searchIconValue, setSearchIconValue] = useState("");
  const [searchedIcon, setSearchIcons] = useState([]);
  const [finalWebSites, setFinalWebSites] = useState([]);
  const [websites, setWebsites] = useState([]);
  const handleAddNewWebLink = () => {
    setWebsites([
      ...websites,
      { _id: shortId(), name: "", link: "", icon: "", image: "" },
    ]);
  };
  const handleremoveWebLink = (_id) => {
    const webLink = websites.find((link) => link._id === _id);
    if (webLink?.image) {
      handleRemoveCustomIcon(webLink.image, _id);
    }
    const tempWebLinks = websites.filter((link) => link._id !== _id);
    setWebsites(tempWebLinks);
  };
  const handleUpdateWebLinksLink = () => {
    let check = true;
    const tempArray = [];
    websites.forEach((e) => {
      const item = JSON.parse(JSON.stringify(e));
      if (!item.name || !item.link) {
        check = false;
        setIsErrorModalVisible(true);
        return;
      } else {
        delete item._id;
        tempArray.push(item);
      }
    });
    if (check) {
      setFinalWebSites(tempArray);
    }
  };
  const onWebsiteValueChange = (e, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          [e.target.name]:
            e.target.name === "link"
              ? e.target.value.replace("https://", "")
              : e.target.value,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddIcon = (_id, icon) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: icon,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setIconModal("");
    setWebsites(existingWebsites);
  };
  const handleRemoveIcon = (_id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddCustomIcon = ({ file, onSuccess, onError }, _id) => {
    const options = {
      signal: controller.signal,
      maxSizeMB: 0.05,
    };
    setIsUploadingImage(true);
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("customIcon", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const existingWebsites = [...websites];
            for (let index = 0; index < websites.length; index++) {
              if (_id === existingWebsites[index]?._id) {
                const toChangeWebsite = { ...existingWebsites[index] };
                const tempWebsite = {
                  ...toChangeWebsite,
                  image: data.customIcon,
                };
                existingWebsites[index] = tempWebsite;
              }
            }
            console.log({ existingWebsites });
            setIconModal("");
            setWebsites(existingWebsites);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
    // const existingWebsites = [...websites];
    // for (let index = 0; index < websites.length; index++) {
    //   if (_id === existingWebsites[index]?._id) {
    //     const toChangeWebsite = { ...existingWebsites[index] };
    //     const tempWebsite = {
    //       ...toChangeWebsite,
    //       icon: icon,
    //     };
    //     existingWebsites[index] = tempWebsite;
    //   }
    // }
    // setIconModal("");
    // setWebsites(existingWebsites);
  };
  const handleRemoveCustomIcon = (image, _id) => {
    setIsRemoving(true);
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {
        setIsRemoving(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        setIsRemoving(false);
      });
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          image: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };

  const handleSearchIcon = () => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    const searchedIcon = iconNames.filter((item) => {
      return item.match(searchIconValue.toLowerCase());
    });
    if (searchedIcon.length > 0) {
      setSearchIcons(searchedIcon);
    } else {
      setSearchIcons([]);
    }
  };
  const debounced = useDebouncedCallback(() => {
    handleSearchIcon();
  }, 500);
  useEffect(() => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    debounced(searchIconValue);
  }, [debounced, searchIconValue]);
  // profile image

  const [profileImageList, setProfileImageList] = useState([]);
  const [profileImage, setProfileImage] = useState();
  const postProfileImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("profileImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.profileImage,
              status: "done",
              url: Domain + "/data/" + data.profileImage,
            };

            setProfileImageList([...profileImageList, newData]);
            setProfileImage(newData);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };

  // bg Image

  const [bgImageList, setBgImageList] = useState([]);
  const [bgImage, setBgImage] = useState();
  const postBgImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();
    // formData.append("bgImage", file);

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("bgImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.bgImage,
              status: "done",
              url: Domain + "/data/" + data.bgImage,
            };

            setBgImageList([...bgImageList, newData]);
            setBgImage(newData);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  //  QR Settings
  const [pPicker, setPPicker] = useState(false);
  const [sPicker, setSPicker] = useState(false);
  const [qrSetting, setQrSetting] = useState({
    size: 256,
    quietZone: 10,
    ecLevel: "L",
    bgColor: "#FFFFFF",
    fgColor: "#000000",
    logoImage: "",
    logoWidth: 50,
    logoHeight: 50,
    logoOpacity: 1,
    qrStyle: "squares",
    eyeRadius: 0,
  });
  // qr image

  const [logoImageList, setLogoImageList] = useState([]);
  const postLogoImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("logoImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.logoImage,
              status: "done",
              url: Domain + "/data/" + data.logoImage,
            };

            setLogoImageList([...logoImageList, newData]);

            setQrSetting({ ...qrSetting, logoImage: newData?.name });
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };

  const handleCopyLink = () =>
    navigator.clipboard
      .writeText(
        `${
          process.env.REACT_APP_DOMAIN_URL || "https://wavecodes.com.au"
        }/wc/${link}`
      )
      .then(() => message.success("copied"));

  // image remove

  const [isRemoving, setIsRemoving] = useState(false);
  const handleImageRemove = (image) => {
    setIsRemoving(true);
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {
        setIsRemoving(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        setIsRemoving(false);
      });
  };

  // image dimensions
  // const [profileImageDimensions, setProfileImageDimensions] = useState();
  return (
    <Layout heading="Create Wave Card">
      <Helmet>
        <title>Dynamic Wave Cards | Create</title>
      </Helmet>
      <Row className="mainContainer">
        <Col span={16} className="subContainer">
          <Row style={{ maxWidth: "unset" }}>
            <Col md={20}>
              <Form
                className="create-qr-form"
                scrollToFirstError
                form={form}
                onFinish={(e) => {
                  const {
                    fName,
                    lName,
                    fNamePrefix,
                    lNameSuffix,
                    email,
                    email2,
                    address,
                    postalAddress,
                    company,
                    mobile,
                    mobile2,
                    summary,
                    phone,
                    phone2,
                    jobTitle,
                  } = basicInfo;
                  setIsErrorModalVisible(!basicInfo?.fName);
                  const newFilelist = fileList.map((f) => f?.name);
                  const { primary, secondary } = colors;
                  const d = {
                    pColor: primary,
                    sColor: secondary,
                    fName,
                    lName,
                    fNamePrefix,
                    lNameSuffix,
                    email,
                    email2,
                    address,
                    postalAddress,
                    jobTitle,
                    company,
                    mobile,
                    mobile2,
                    summary,
                    link,
                    phone,
                    phone2,
                    sectionOrder,
                    images: newFilelist,
                    webLinks: finalWebSites,
                    youtubeLinks: e.youtubelinks,
                    locationInfo,
                    showQr,
                    socialLinks: [
                      {
                        name: "facebook",
                        link: form?.getFieldValue("facebook")
                          ? form
                              ?.getFieldValue("facebook")
                              ?.includes("facebook.com")
                            ? form?.getFieldValue("facebook")
                            : "facebook.com/" + form?.getFieldValue("facebook")
                          : "",
                      },
                      {
                        name: "instagram",
                        link: form?.getFieldValue("instagram")
                          ? form
                              ?.getFieldValue("instagram")
                              ?.includes("instagram.com")
                            ? form?.getFieldValue("instagram")
                            : "instagram.com/" +
                              form?.getFieldValue("instagram")
                          : "",
                      },
                      {
                        name: "linkedin",
                        link: form?.getFieldValue("linkedin")
                          ? form
                              ?.getFieldValue("linkedin")
                              ?.includes("linkedin.com/in/")
                            ? form.getFieldValue("linkedin")
                            : "linkedin.com/in/" +
                              form.getFieldValue("linkedin")
                          : "",
                      },
                      {
                        name: "twitter",
                        link: form?.getFieldValue("twitter")
                          ? form
                              ?.getFieldValue("twitter")
                              ?.includes("twitter.com")
                            ? form?.getFieldValue("twitter")
                            : "twitter.com/" + form?.getFieldValue("twitter")
                          : "",
                      },
                      {
                        name: "skype",
                        link: form?.getFieldValue("skype")
                          ? form?.getFieldValue("skype")?.includes("skype.com")
                            ? form?.getFieldValue("skype")
                            : "skype.com/" + form?.getFieldValue("skype")
                          : "",
                      },
                      {
                        name: "behance",
                        link: form?.getFieldValue("behance")
                          ? form
                              ?.getFieldValue("behance")
                              ?.includes("behance.com")
                            ? form?.getFieldValue("behance")
                            : "behance.com/" + form?.getFieldValue("behance")
                          : "",
                      },
                      {
                        name: "youtube",
                        link: form?.getFieldValue("youtube")
                          ? form
                              ?.getFieldValue("youtube")
                              ?.includes("youtube.com")
                            ? form?.getFieldValue("youtube")
                            : "youtube.com/" + form?.getFieldValue("youtube")
                          : "",
                      },
                      {
                        name: "whatsapp",
                        link: form?.getFieldValue("whatsapp")
                          ? form?.getFieldValue("whatsapp")?.includes("wa.me")
                            ? form?.getFieldValue("whatsapp")
                            : "wa.me/" + form?.getFieldValue("whatsapp")
                          : "",
                      },
                      {
                        name: "maps",
                        link: form?.getFieldValue("maps")
                          ? form?.getFieldValue("maps")?.includes("goo.gl/maps")
                            ? form?.getFieldValue("maps")
                            : "goo.gl/maps/" + form?.getFieldValue("maps")
                          : "",
                      },
                      { name: "mail", link: form?.getFieldValue("mail") },
                      {
                        name: "telegram",
                        link: form?.getFieldValue("telegram")
                          ? form?.getFieldValue("telegram")?.includes("t.me")
                            ? form?.getFieldValue("telegram")
                            : "t.me/" + form?.getFieldValue("telegram")
                          : "",
                      },
                      {
                        name: "tiktok",
                        link: form?.getFieldValue("tiktok")
                          ? form
                              ?.getFieldValue("tiktok")
                              ?.includes("vt.tiktok.com")
                            ? form?.getFieldValue("tiktok")
                            : "vt.tiktok.com/" + form?.getFieldValue("tiktok")
                          : "",
                      },
                      {
                        name: "snapchat",
                        link: form?.getFieldValue("snapchat")
                          ? form
                              ?.getFieldValue("snapchat")
                              ?.includes("snapchat.com/add")
                            ? form?.getFieldValue("snapchat")
                            : "snapchat.com/add/" +
                              form?.getFieldValue("snapchat")
                          : "",
                      },
                    ],
                    // socialLinks: [
                    //   {
                    //     name: "facebook",
                    //     link: e?.facebook && `facebook.com/${e?.facebook}`,
                    //   },
                    //   {
                    //     name: "instagram",
                    //     link: e?.instagram && `instagram.com/${e?.instagram}`,
                    //   },
                    //   {
                    //     name: "linkedin",
                    //     link: e?.linkedin && `linkedin.com/${e?.linkedin}`,
                    //   },
                    //   {
                    //     name: "twitter",
                    //     link: e?.twitter && `twitter.com/${e?.twitter}`,
                    //   },
                    //   {
                    //     name: "skype",
                    //     link: e?.skype && `skype.com/${e?.skype}`,
                    //   },
                    //   {
                    //     name: "behance",
                    //     link: e?.behance && `behance.com/${e?.behance}`,
                    //   },
                    //   {
                    //     name: "youtube",
                    //     link:
                    //       e?.youtube &&
                    //       `youtube.com/${e?.youtube.split("youtube.com")[1]}`,
                    //   },
                    //   {
                    //     name: "whatsapp",
                    //     link: e?.whatsapp && `wa.me/${e?.whatsapp}`,
                    //   },
                    //   {
                    //     name: "maps",
                    //     link: e?.maps && `goo.gl/maps/${e?.maps}`,
                    //   },
                    //   { name: "mail", link: e?.mail && `mailto:${e?.mail}` },
                    //   {
                    //     name: "telegram",
                    //     link: e?.telegram && `t.me/${e?.telegram}`,
                    //   },
                    //   {
                    //     name: "tiktok",
                    //     link: e?.tiktok && `vt.tiktok.com/${e?.tiktok}`,
                    //   },
                    //   {
                    //     name: "snapchat",
                    //     link: e?.snapchat && `snapchat.com/add/${e?.snapchat}`,
                    //   },
                    // ],
                    qrSetting: { ...qrSetting },
                  };
                  if (bgImageList.length > 0) d.bgImage = bgImageList[0]?.name;
                  if (profileImageList.length > 0)
                    d.profileImage = profileImageList[0]?.name;
                  if ((!fName && !email) || fName === "Your") {
                  } else {
                    addQr(d);
                  }
                }}
                onFinishFailed={(e) => setIsErrorModalVisible(true)}
              >
                <Collapse
                  defaultActiveKey={["1"]}
                  bordered={false}
                  className="site-collapse-custom-panel"
                  expandIcon={({ isActive }) => (
                    <DoubleRightOutlined rotate={isActive ? 90 : 0} />
                  )}
                >
                  <Panel header="Design and Customize" key={1}>
                    <span
                      onClick={() => {
                        setTogglePicker(false);
                        setTogglePicker1(false);
                      }}
                    >
                      <h3> Background Colors</h3>
                      <Item name="color">
                        <Row
                          gutter={10}
                          style={{
                            marginTop: 24,
                            width: "25rem",
                          }}
                        >
                          <Col span={4}>
                            <h4>Presets</h4>
                          </Col>
                          <Col span={20}>
                            <Space className="color-selection-containter">
                              <div className="color-selection-subContainter">
                                <div
                                  className="color-selection-box"
                                  onClick={() => {
                                    setColors({
                                      primary: primary,
                                      secondary: primaryDark,
                                    });
                                  }}
                                >
                                  <div
                                    className="top"
                                    style={{ background: primary }}
                                  />
                                  <div
                                    className="bottom"
                                    style={{ background: primaryDark }}
                                  />
                                </div>
                                <div
                                  className="color-selection-box"
                                  onClick={() => {
                                    setColors({
                                      primary: "#E7A14A",
                                      secondary: "#10171E",
                                    });
                                  }}
                                >
                                  <div
                                    className="top"
                                    style={{ background: "#E7A14A" }}
                                  />
                                  <div
                                    className="bottom"
                                    style={{ background: "#10171E" }}
                                  />
                                </div>
                              </div>
                              <div className="color-selection-subContainter">
                                <div
                                  className="color-selection-box"
                                  onClick={() => {
                                    setColors({
                                      primary: "#333333",
                                      secondary: "#ED6363",
                                    });
                                  }}
                                >
                                  <div
                                    className="top"
                                    style={{ background: "#333333" }}
                                  />
                                  <div
                                    className="bottom"
                                    style={{ background: "#ED6363" }}
                                  />
                                </div>
                                <div
                                  className="color-selection-box"
                                  onClick={() => {
                                    setColors({
                                      primary: "#CEB996",
                                      secondary: "#322F44",
                                    });
                                  }}
                                >
                                  <div
                                    className="top"
                                    style={{ background: "#CEB996" }}
                                  />
                                  <div
                                    className="bottom"
                                    style={{ background: "#322F44" }}
                                  />
                                </div>
                              </div>
                            </Space>
                          </Col>
                        </Row>

                        {/* color picker */}
                        <Row
                          gutter={10}
                          style={{
                            marginTop: 24,
                            width: "25rem",
                            alignItems: "center",
                          }}
                        >
                          <Col span={4}>
                            <h4>Select Colors</h4>
                          </Col>
                          <Col className="colorPickerContainer" span={20}>
                            <Col
                              span={10}
                              style={{
                                marginBottom: ".5rem",
                              }}
                            >
                              <Input
                                onChange={(e) =>
                                  setColors({
                                    ...colors,
                                    primary: e.target.value,
                                  })
                                }
                                size="large"
                                prefix={
                                  <>
                                    <CgColorPicker
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setTogglePicker(!togglePicker);
                                      }}
                                      style={{
                                        background: colors.primary,
                                        color: "white",
                                        width: 30,
                                        padding: 5,
                                        height: "100%",
                                        borderRadius: 8,
                                      }}
                                    />

                                    {togglePicker && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: "2",
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 55,
                                          }}
                                        >
                                          <SketchPicker
                                            color={colors.primary}
                                            onChange={(e) =>
                                              setColors({
                                                ...colors,
                                                primary: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                }
                                style={{ borderRadius: 8 }}
                                value={colors.primary}
                              />
                            </Col>
                            <Col span={10}>
                              <Input
                                onChange={(e) =>
                                  setColors({
                                    ...colors,
                                    secondary: e.target.value,
                                  })
                                }
                                size="large"
                                prefix={
                                  <>
                                    <CgColorPicker
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setTogglePicker1(!togglePicker1);
                                      }}
                                      style={{
                                        background: colors.secondary,
                                        color: "white",
                                        width: 30,
                                        padding: 5,
                                        height: "100%",
                                        borderRadius: 8,
                                      }}
                                    />

                                    {togglePicker1 && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: "2",
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 55,
                                          }}
                                        >
                                          <SketchPicker
                                            color={colors.secondary}
                                            onChange={(e) => {
                                              setColors({
                                                ...colors,
                                                secondary: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                }
                                style={{ borderRadius: 8 }}
                                value={colors.secondary}
                              />
                            </Col>
                          </Col>
                        </Row>

                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col>
                            <h4>Profile Image</h4>
                            <p className="subText">Size: 500 KB</p>
                            <p className="subText">Dimension: 120 x 120 px </p>
                            <p className="subText">
                              Max Dimensions: 1024 x 1024 px{" "}
                            </p>
                          </Col>
                          <Col>
                            <ImgCrop
                              rotate
                              modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                              quality={1}
                              shape="round"
                              fillColor="#00000000"
                            >
                              <Upload
                                className="fileList-upload-images"
                                maxCount={1}
                                customRequest={postProfileImage}
                                listType="picture-card"
                                fileList={profileImageList}
                                onPreview={handlePreview}
                                onRemove={(e) => handleImageRemove(e?.name)}
                                onChange={(e) => {
                                  setProfileImageList(
                                    profileImageList.filter(
                                      (f) => f.uid !== e?.file?.uid
                                    )
                                  );
                                  setProfileImage();
                                }}
                                // beforeUpload={(file) => {
                                //   const isLt2M = file.size / 1024 <= 1024; //less than 500 KB
                                //   // const isLt2M = file.size / 1024 / 1024 < 2;
                                //   if (!isLt2M) {
                                //     file.flag = true;
                                //     message.error(
                                //       "Please upload image less than 500 KB"
                                //     );
                                //     return false;
                                //   }
                                //   return true;
                                // }}
                                accept="image/*"
                              >
                                {profileImageList.length === 1 ? null : (
                                  <PlusOutlined />
                                )}
                              </Upload>
                            </ImgCrop>
                          </Col>
                        </Row>
                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col>
                            <h4>Background Image</h4>
                            <p className="subText">Size: 500 KB</p>
                            <p className="subText">Dimension: 550 x 300 px </p>
                            <p className="subText">
                              Max Dimensions: 1024 x 1024 px{" "}
                            </p>
                          </Col>
                          <Col>
                            <ImgCrop
                              rotate
                              quality={1}
                              modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                              minZoom={1}
                              maxZoom={10}
                              aspect={2 / 1}
                              modalWidth={530}
                              fillColor="#00000000"
                            >
                              <Upload
                                className="fileList-upload-images"
                                maxCount={1}
                                customRequest={postBgImage}
                                listType="picture-card"
                                fileList={bgImageList}
                                onPreview={handlePreview}
                                onRemove={(e) => handleImageRemove(e?.name)}
                                onChange={(e) => {
                                  setBgImageList(
                                    bgImageList.filter(
                                      (f) => f.uid !== e?.file?.uid
                                    )
                                  );
                                  setBgImage();
                                }}
                                // beforeUpload={(file) => {
                                //   const isLt2M = file.size / 1024 <= 1024; //less than 500 KB
                                //   // const isLt2M = file.size / 1024 / 1024 < 2;
                                //   if (!isLt2M) {
                                //     file.flag = true;
                                //     message.error(
                                //       "Please upload image less than 500 KB"
                                //     );
                                //     return false;
                                //   }
                                //   return true;
                                // }}
                                accept="image/*"
                              >
                                {bgImageList.length === 1 ? null : (
                                  <PlusOutlined />
                                )}
                              </Upload>
                            </ImgCrop>
                          </Col>
                        </Row>
                      </Item>
                    </span>
                  </Panel>
                  <Panel header="Basic Information" key={2}>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Name</h4>
                      </Col>
                      <Col xs={24} md={10}>
                        <Row gutter={24}>
                          <Col xs={10} md={10}>
                            <Item name="fNamePrefix">
                              <Input
                                size="large"
                                name="fNamePrefix"
                                value={basicInfo.fNamePrefix}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Prefix"
                              />
                            </Item>
                          </Col>
                          <Col xs={14} md={13}>
                            <Item
                              name="fName"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                name="fName"
                                value={basicInfo.fName}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="First Name"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={10}>
                        <Row gutter={24} justify="space-between">
                          <Col xs={14} md={13}>
                            <Item name="lName">
                              <Input
                                size="large"
                                name="lName"
                                value={basicInfo.lName}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Last Name"
                              />
                            </Item>
                          </Col>
                          <Col xs={10} md={10}>
                            <Item name="lNameSuffix">
                              <Input
                                size="large"
                                name="lNameSuffix"
                                value={basicInfo.lNameSuffix}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Suffix"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={24} md={12}>
                        <Row xs={24} md={12}>
                          <Col xs={8} md={8}>
                            <h4>Mobile Number</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item name="mobile">
                              <Input
                                size="large"
                                name="mobile"
                                value={basicInfo.mobile}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Number"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row justify="space-between">
                          <Col xs={8} md={8}>
                            <h4>Mobile Number 2</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item name="mobile2">
                              <Input
                                size="large"
                                name="mobile2"
                                value={basicInfo.mobile2}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Number"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={24} md={12}>
                        <Row xs={24} md={12}>
                          <Col xs={8} md={8}>
                            <h4>Phone Number</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item name="phone">
                              <Input
                                size="large"
                                name="phone"
                                value={basicInfo.phone}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Number"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row justify="space-between">
                          <Col xs={8} md={8}>
                            <h4>Phone Number 2</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item name="phone2">
                              <Input
                                size="large"
                                name="phone2"
                                value={basicInfo.phone2}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Number"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={24} md={12}>
                        <Row xs={24} md={12}>
                          <Col xs={8} md={8}>
                            <h4>Email</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item
                              initialValue={basicInfo?.email}
                              name="email"
                              rules={[
                                {
                                  type: "email",
                                  message: "Please Enter correct Email!",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                name="email"
                                value={basicInfo.email}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Your Email Id"
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={24} md={12}>
                        <Row justify="space-between">
                          <Col xs={8} md={8}>
                            <h4>Email 2</h4>
                          </Col>
                          <Col xs={16} md={15}>
                            <Item
                              initialValue={basicInfo?.email}
                              name="email2"
                              rules={[
                                {
                                  type: "email",
                                  message: "Please Enter correct Email!",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                name="email2"
                                value={basicInfo.email2}
                                onChange={handleBasicInfo}
                                style={{ borderRadius: 8 }}
                                placeholder="Your Email Id "
                              />
                            </Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Job Title</h4>
                      </Col>
                      <Col xs={24} md={20}>
                        <Item name="jobTitle">
                          <Input
                            size="large"
                            name="jobTitle"
                            value={basicInfo.jobTitle}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Your Job Title"
                          />
                        </Item>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Company</h4>
                      </Col>
                      <Col xs={24} md={20}>
                        <Item name="company">
                          <Input
                            size="large"
                            name="company"
                            value={basicInfo.company}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Your Company Name"
                          />
                        </Item>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Address</h4>
                      </Col>
                      <Col xs={24} md={20}>
                        <Item name="address">
                          <LocationSearch
                            placeholder="Your Address"
                            value={basicInfo.address}
                            onChange={handleBasicInfo}
                            name="address"
                            setLocationInfo={setLocationInfo}
                          />
                        </Item>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Postal Address</h4>
                      </Col>
                      <Col xs={24} md={20}>
                        <Item name="postalAddress">
                          <Input.TextArea
                            size="large"
                            name="postalAddress"
                            value={basicInfo.postalAddress}
                            onChange={handleBasicInfo}
                            autoSize={{ minRows: 3 }}
                            maxLength={150}
                            style={{ borderRadius: 8 }}
                            placeholder="Your Postal Address"
                          />
                        </Item>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col xs={8} md={4}>
                        <h4>Summary</h4>
                      </Col>
                      <Col xs={24} md={20}>
                        <Item
                          name="summary"
                          initialValue={basicInfo?.summary || ""}
                        >
                          <ReactQuill
                            name="summary"
                            value={basicInfo.summary || ""}
                            onChange={(e) => {
                              const target = {
                                name: "summary",
                                value: e,
                              };
                              const temp = { target };
                              handleBasicInfo(temp);
                            }}
                            placeholder="A brief description about yourself"
                            style={{ borderRadius: 8 }}
                          />
                        </Item>
                      </Col>
                    </Row>
                  </Panel>
                  <Panel header="Web Links" key={3}>
                    <Row span={24} align="space-between">
                      <Col xs={24} md={4}>
                        <h4>Weblinks</h4>
                        <p className="subText">
                          Please Input your website link in the first field.
                        </p>
                        <p
                          style={{
                            color: danger,
                            fontSize: 11,
                            fontWeight: "500",
                          }}
                        >
                          * First Link will be saved in your vcf file{" "}
                        </p>
                      </Col>
                      <Col xs={24} md={19}>
                        <div style={{ marginBottom: "1rem" }}>
                          {websites.map((website, index) => {
                            return (
                              <Space
                                key={index}
                                wrap={true}
                                style={{ marginBottom: "1rem" }}
                              >
                                {website?.icon ? (
                                  <i
                                    onClick={() => {
                                      handleRemoveIcon(website._id);
                                    }}
                                    className={`fas fa-${website?.icon} fa-2x`}
                                    style={{
                                      margin: "1rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                ) : website?.image ? (
                                  <img
                                    onClick={() => {
                                      handleRemoveCustomIcon(
                                        website.image,
                                        website._id
                                      );
                                    }}
                                    src={Domain + "/data/" + website.image}
                                    style={{
                                      width: "2rem",
                                      height: "2rem",
                                      cursor: "pointer",
                                      margin: "1rem",
                                    }}
                                    alt="icon"
                                  />
                                ) : (
                                  <Button
                                    size="large"
                                    onClick={() => setIconModal(website._id)}
                                    style={{ borderRadius: 8 }}
                                  >
                                    Icon
                                  </Button>
                                )}

                                <Input
                                  name="name"
                                  style={{ borderRadius: 8 }}
                                  placeholder="Link"
                                  size="large"
                                  value={website.name}
                                  onChange={(e) =>
                                    onWebsiteValueChange(e, website._id)
                                  }
                                />

                                <Input
                                  name="link"
                                  style={{ borderRadius: 8 }}
                                  size="large"
                                  value={website.link}
                                  placeholder="www.mywebsiteurl.com"
                                  prefix={
                                    <>
                                      <LinkOutlined
                                        style={{ paddingRight: 5 }}
                                      />{" "}
                                      https://
                                    </>
                                  }
                                  onChange={(e) =>
                                    onWebsiteValueChange(e, website._id)
                                  }
                                />

                                <Button
                                  size="large"
                                  danger
                                  onClick={() => {
                                    handleremoveWebLink(website._id);
                                  }}
                                  style={{ borderRadius: 8 }}
                                  icon={
                                    <DeleteOutlined
                                      className="linkDeleteIcon"
                                      style={{ fontSize: 18 }}
                                    />
                                  }
                                >
                                  Remove
                                </Button>
                              </Space>
                            );
                          })}
                        </div>
                        <Button
                          type="dashed"
                          onClick={() => {
                            handleAddNewWebLink();
                          }}
                          block
                          icon={<PlusOutlined />}
                          style={{ borderRadius: 8, marginBottom: "2rem" }}
                        >
                          Add Links
                        </Button>
                        <Button
                          size="large"
                          onClick={() => {
                            handleUpdateWebLinksLink();
                          }}
                          style={{ borderRadius: 8 }}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </Panel>
                  <Panel header="Images Upload" key={4}>
                    <Row span={24}>
                      <Col xs={24} md={4}>
                        <h4>Images</h4>
                        <p className="subText">Max 3/{fileList.length}</p>
                        <p className="subText">Size: 500 KB</p>
                      </Col>
                      <Col xs={24} md={20}>
                        <ImgCrop
                          rotate
                          modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                          quality={1}
                          aspect={9 / 6}
                          modalWidth={720}
                          shape="rect"
                          fillColor="#00000000"
                        >
                          <Upload
                            className="fileList-upload-images"
                            maxCount={3}
                            customRequest={postImage}
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onRemove={(e) => handleImageRemove(e?.name)}
                            onChange={(e) => {
                              setFileList(
                                fileList.filter((f) => f.uid !== e?.file?.uid)
                              );
                            }}
                            // beforeUpload={(file) => {
                            //   const isLt2M = file.size / 1024 <= 1024; //less than 500 KB
                            //   if (!isLt2M) {
                            //     file.flag = true;
                            //     message.error(
                            //       "Please upload image less than 500 KB"
                            //     );
                            //     return false;
                            //   }
                            //   return true;
                            // }}
                            accept="image/*"
                          >
                            {fileList.length >= 3 ? null : <PlusOutlined />}
                          </Upload>
                        </ImgCrop>
                      </Col>
                    </Row>
                  </Panel>
                  {subscribedPlan?.paymentStatus === "SUCCESS" ||
                  role === "superadmin" ? (
                    <Panel header="Youtube Videos" key={5}>
                      <Row span={10}>
                        <Col xs={24} md={4}>
                          <h4>Youtube</h4>
                          <p className="subText">
                            Please Input youtube video link in the first field.
                          </p>
                        </Col>
                        <Col xs={24} md={19}>
                          <Form.List name="youtubelinks">
                            {(fields, { add, remove, move }) => {
                              return (
                                <>
                                  {fields.map(({ key, name, ...restField }) => {
                                    return (
                                      <Space
                                        key={key}
                                        className="webLinkMain"
                                        align="baseline"
                                      >
                                        <Form.Item
                                          {...restField}
                                          initialValue=""
                                          name={[name, "link"]}
                                          rules={[
                                            {
                                              required: true,
                                              message: "Missing Url",
                                            },
                                          ]}
                                        >
                                          <Input
                                            style={{ borderRadius: 8 }}
                                            size="large"
                                            placeholder="www.youtube.com/url"
                                            prefix={
                                              <>
                                                <LinkOutlined
                                                  style={{ paddingRight: 5 }}
                                                />
                                              </>
                                            }
                                          />
                                        </Form.Item>

                                        <Button
                                          size="large"
                                          danger
                                          onClick={() => remove(name)}
                                          style={{ borderRadius: 8 }}
                                          icon={
                                            <DeleteOutlined
                                              className="linkDeleteIcon"
                                              style={{ fontSize: 18 }}
                                            />
                                          }
                                        >
                                          Remove
                                        </Button>
                                      </Space>
                                    );
                                  })}
                                  <Form.Item>
                                    <Button
                                      disabled={
                                        form?.getFieldValue("youtubelinks")
                                          ?.length > 2
                                          ? true
                                          : false
                                      }
                                      type="dashed"
                                      onClick={() => add()}
                                      block
                                      icon={<PlusOutlined />}
                                      style={{ borderRadius: 8 }}
                                    >
                                      Add Links
                                    </Button>
                                  </Form.Item>
                                  <Button
                                    size="large"
                                    onClick={() => {
                                      form?.getFieldValue("youtubelinks")
                                        ?.length === 0 &&
                                        setYoutubeLinks(
                                          form?.getFieldValue("youtubelinks")
                                        );

                                      form
                                        ?.getFieldValue("youtubelinks")
                                        ?.map((v) => {
                                          if (!v?.link) {
                                            setIsErrorModalVisible(true);
                                          } else {
                                            setYoutubeLinks(
                                              form?.getFieldValue(
                                                "youtubelinks"
                                              )
                                            );
                                          }
                                          return true;
                                        });
                                    }}
                                    style={{ borderRadius: 8 }}
                                  >
                                    Update
                                  </Button>
                                </>
                              );
                            }}
                          </Form.List>
                        </Col>
                      </Row>
                    </Panel>
                  ) : null}
                  <Panel header="Social Links" key={6}>
                    <Row xs={12} md={24} align="center" style={{ gap: 15 }}>
                      {/* Facebook */}
                      <div
                        onClick={() => setIsFacebook(!isFacebook)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isFacebook ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiFacebookBoxFill
                          color={isFacebook ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Instagram */}
                      <div
                        onClick={() => setIsInstagram(!isInstagram)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isInstagram ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiInstagramFill
                          color={isInstagram ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* linkedin */}
                      <div
                        onClick={() => setIsLinkedin(!isLinkedin)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isLinkedin ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiLinkedinBoxFill
                          color={isLinkedin ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Twitter */}
                      <div
                        onClick={() => setIsTwitter(!isTwitter)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isTwitter ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiTwitterFill
                          color={isTwitter ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Skype */}
                      <div
                        onClick={() => setIsSkype(!isSkype)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isSkype ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiSkypeFill
                          color={isSkype ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Behance */}
                      <div
                        onClick={() => setIsBehance(!isBehance)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isBehance ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiBehanceFill
                          color={isBehance ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Youtube */}
                      <div
                        onClick={() => setIsYoutube(!isYoutube)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isYoutube ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiYoutubeFill
                          color={isYoutube ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                    </Row>
                    <Row
                      xs={12}
                      md={24}
                      align="center"
                      style={{ gap: 15, marginTop: 15 }}
                    >
                      {/* Whatsapp */}
                      <div
                        onClick={() => setIsWhatsapp(!isWhatsapp)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isWhatsapp ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiWhatsappFill
                          color={isWhatsapp ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Maps */}
                      <div
                        onClick={() => setIsMaps(!isMaps)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isMaps ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiMap2Fill
                          color={isMaps ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>

                      {/* Mail */}
                      <div
                        onClick={() => setIsMail(!isMail)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isMail ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiMailFill
                          color={isMail ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Telegram */}
                      <div
                        onClick={() => setIsTelegram(!isTelegram)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isTelegram ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiTelegramFill
                          color={isTelegram ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Tiktok */}
                      <div
                        onClick={() => setIsTiktok(!isTiktok)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isTiktok ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <FaTiktok
                          color={isTiktok ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                      {/* Snapchat */}
                      <div
                        onClick={() => setIsSnapchat(!isSnapchat)}
                        style={{
                          cursor: "pointer",
                          width: 60,
                          height: 60,
                          borderRadius: 30,
                          border: `1px solid ${
                            isSnapchat ? primaryDark : "lightgray"
                          }`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <RiSnapchatFill
                          color={isSnapchat ? primaryDark : "lightgray"}
                          style={{ fontSize: 30 }}
                        />
                      </div>
                    </Row>
                    {/* Social Inputs */}
                    <Col xs={24} md={24} style={{ marginTop: 15 }}>
                      {isFacebook && (
                        <Item
                          name="facebook"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="facebook"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiFacebookBoxFill
                                  color="lightgray"
                                  style={{
                                    fontSize: 30,
                                    marginRight: 10,
                                  }}
                                />
                                facebook.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isInstagram && (
                        <Item
                          name="instagram"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="instagram"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiInstagramFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                instagram.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isLinkedin && (
                        <Item
                          name="linkedin"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="linkedin"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiLinkedinBoxFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                linkedin.com/in/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isTwitter && (
                        <Item
                          name="twitter"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="twitter"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiTwitterFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                twitter.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isSkype && (
                        <Item
                          name="skype"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="skype"
                            style={{ borderRadius: 8 }}
                            placeholder="Skype Id"
                            prefix={
                              <>
                                <RiSkypeFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                skype.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isBehance && (
                        <Item
                          name="behance"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="behance"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiBehanceFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                behance.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isYoutube && (
                        <Item
                          name="youtube"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="youtube"
                            style={{ borderRadius: 8 }}
                            placeholder="yourpage"
                            prefix={
                              <>
                                <RiYoutubeFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                youtube.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isWhatsapp && (
                        <Item
                          name="whatsapp"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="whatsapp"
                            style={{ borderRadius: 8 }}
                            placeholder="phonenumber"
                            prefix={
                              <>
                                <RiWhatsappFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                wa.me/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isMaps && (
                        <Item
                          name="maps"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="maps"
                            style={{ borderRadius: 8 }}
                            placeholder="id"
                            prefix={
                              <>
                                <RiMap2Fill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                goo.gl/maps/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isMail && (
                        <Item
                          name="mail"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="mail"
                            style={{ borderRadius: 8 }}
                            placeholder="xyz@domain.com"
                            prefix={
                              <RiMailFill
                                color="lightgray"
                                style={{
                                  fontSize: 30,
                                  marginRight: 10,
                                }}
                              />
                            }
                          />
                        </Item>
                      )}
                      {isTelegram && (
                        <Item
                          name="telegram"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="telegram"
                            style={{ borderRadius: 8 }}
                            placeholder="username"
                            prefix={
                              <>
                                <RiTelegramFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                t.me/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isTiktok && (
                        <Item
                          name="tiktok"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="tiktok"
                            style={{ borderRadius: 8 }}
                            placeholder="usename"
                            prefix={
                              <>
                                <FaTiktok
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                vt.tiktok.com/
                              </>
                            }
                          />
                        </Item>
                      )}
                      {isSnapchat && (
                        <Item
                          name="snapchat"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            name="snapchat"
                            style={{ borderRadius: 8 }}
                            placeholder="username"
                            prefix={
                              <>
                                <RiSnapchatFill
                                  color="lightgray"
                                  style={{ fontSize: 30, marginRight: 10 }}
                                />
                                snapchat.com/add
                              </>
                            }
                          />
                        </Item>
                      )}
                    </Col>
                  </Panel>
                  <Panel header="Wave Code Styles" key={7}>
                    <span
                      onClick={() => {
                        setPPicker(false);
                        setSPicker(false);
                      }}
                    >
                      <Row gutter={10} style={{ marginTop: 24 }}>
                        <Col xs={12} md={4}>
                          <h4>Show Qr code in profile</h4>
                        </Col>
                        <Col xs={12} md={20}>
                          <Switch
                            checked={showQr}
                            onChange={(e) => {
                              setShowQr(e);
                            }}
                          />
                        </Col>
                      </Row>
                      <Row span={24} justify="space-between">
                        <Col lg={24} xl={14}>
                          <Item name="color">
                            {/* color picker */}
                            <Row span={24} style={{ marginTop: 24 }}>
                              <Col xs={24} md={4}>
                                <h4>Select Colors</h4>
                              </Col>
                              <Col xs={24} md={9} className="ecLevel">
                                <Input
                                  onChange={(e) =>
                                    setQrSetting({
                                      ...qrSetting,
                                      fgColor: e.target.value,
                                    })
                                  }
                                  size="large"
                                  prefix={
                                    <>
                                      <CgColorPicker
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPPicker(!pPicker);
                                        }}
                                        style={{
                                          background: qrSetting.fgColor,
                                          color: "lightgray",
                                          border: "1px solid lightgray",
                                          width: 30,
                                          padding: 5,
                                          height: "100%",
                                          borderRadius: 8,
                                        }}
                                      />

                                      {pPicker && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: -350,
                                          }}
                                        >
                                          <SketchPicker
                                            color={qrSetting.fgColor}
                                            onChange={(e) =>
                                              setQrSetting({
                                                ...qrSetting,
                                                fgColor: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              })
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  }
                                  style={{ borderRadius: 8 }}
                                  value={qrSetting.fgColor}
                                />
                              </Col>
                              <Col xs={24} md={9} className="ecLevel">
                                <Input
                                  onChange={(e) =>
                                    setQrSetting({
                                      ...qrSetting,
                                      bgColor: e.target.value,
                                    })
                                  }
                                  size="large"
                                  prefix={
                                    <>
                                      <CgColorPicker
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSPicker(!sPicker);
                                        }}
                                        style={{
                                          background: qrSetting.bgColor,
                                          color: "lightgray",
                                          border: "1px solid lightgray",
                                          width: 30,
                                          padding: 5,
                                          height: "100%",
                                          borderRadius: 8,
                                        }}
                                      />

                                      {sPicker && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: -350,
                                          }}
                                        >
                                          <SketchPicker
                                            color={qrSetting.bgColor}
                                            onChange={(e) => {
                                              setQrSetting({
                                                ...qrSetting,
                                                bgColor: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              });
                                            }}
                                          />
                                        </div>
                                      )}
                                    </>
                                  }
                                  style={{ borderRadius: 8 }}
                                  value={qrSetting.bgColor}
                                />
                              </Col>
                            </Row>
                          </Item>
                          <Row span={24} style={{ marginTop: 24 }}>
                            <Col xs={12} md={4}>
                              <h4>EC Level</h4>
                              <p style={{ fontSize: 10, color: "lightgray" }}>
                                *Error Correction
                              </p>
                            </Col>
                            <Col xs={12} md={20}>
                              <Radio.Group
                                value={qrSetting.ecLevel}
                                onChange={(e) =>
                                  setQrSetting({
                                    ...qrSetting,
                                    ecLevel: e.target.value,
                                  })
                                }
                              >
                                <Space
                                  wrap={true}
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <Radio.Button
                                    className="ecLevel"
                                    style={{
                                      borderRadius: 8,
                                    }}
                                    value={"L"}
                                  >
                                    Low
                                  </Radio.Button>
                                  <Radio.Button
                                    style={{
                                      borderRadius: 8,
                                    }}
                                    className="ecLevel"
                                    value={"M"}
                                  >
                                    Medium
                                  </Radio.Button>
                                  <Radio.Button
                                    style={{
                                      borderRadius: 8,
                                    }}
                                    className="ecLevel"
                                    value={"Q"}
                                  >
                                    Quartile
                                  </Radio.Button>
                                  <Radio.Button
                                    style={{
                                      borderRadius: 8,
                                    }}
                                    className="ecLevel"
                                    value={"H"}
                                  >
                                    High
                                  </Radio.Button>
                                </Space>
                              </Radio.Group>
                            </Col>
                          </Row>
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col xs={12} md={4}>
                              <h4>Style</h4>
                            </Col>
                            <Col xs={12} md={20}>
                              <Radio.Group
                                value={qrSetting.qrStyle}
                                onChange={(e) =>
                                  setQrSetting({
                                    ...qrSetting,
                                    qrStyle: e.target.value,
                                  })
                                }
                              >
                                <Space
                                  style={{
                                    display: "flex",
                                  }}
                                  wrap={true}
                                >
                                  <Radio.Button
                                    style={{
                                      borderRadius: 8,
                                    }}
                                    value={"squares"}
                                  >
                                    Squares
                                  </Radio.Button>
                                  <Radio.Button
                                    style={{ borderRadius: 8 }}
                                    value={"dots"}
                                  >
                                    Dots
                                  </Radio.Button>
                                </Space>
                              </Radio.Group>
                            </Col>
                          </Row>
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col xs={12} md={4}>
                              <h4>Eye Radius</h4>
                            </Col>
                            <Col xs={12} md={20}>
                              <Slider
                                defaultValue={qrSetting.eyeRadius}
                                max={50}
                                value={qrSetting.eyeRadius}
                                onChange={(e) =>
                                  setQrSetting({ ...qrSetting, eyeRadius: e })
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={24} xl={9}>
                          <QRCode
                            size={qrSetting.size}
                            value={`${
                              process.env.REACT_APP_DOMAIN_URL ||
                              "https://wavecodes.com.au"
                            }/wc/${link}`}
                            quietZone={qrSetting.quietZone}
                            fgColor={qrSetting.fgColor}
                            bgColor={qrSetting.bgColor}
                            ecLevel={qrSetting.ecLevel}
                            qrStyle={qrSetting.qrStyle}
                            eyeRadius={qrSetting.eyeRadius}
                            logoImage={qrSetting.logoImage}
                            logoWidth={qrSetting.logoWidth}
                            logoHeight={qrSetting.logoHeight}
                            logoOpacity={qrSetting.logoOpacity}
                          />
                        </Col>
                      </Row>

                      <Row gutter={10} style={{ marginTop: 24 }}>
                        <Col xs={12} md={4}>
                          <h4>Logo Image</h4>
                          <p className="subText">Size: 500 KB</p>
                        </Col>
                        <Col sxs={12} md={20}>
                          <ImgCrop
                            rotate
                            modalTitle="Crop Image  *Image previews can be blurred. It will not affect quality of image."
                            quality={1}
                            fillColor="#00000000"
                          >
                            <Upload
                              className="fileList-upload-images"
                              maxCount={1}
                              customRequest={postLogoImage}
                              listType="picture-card"
                              onRemove={(e) => handleImageRemove(e?.name)}
                              fileList={logoImageList}
                              onPreview={handlePreview}
                              onChange={(e) => {
                                setLogoImageList(
                                  logoImageList.filter(
                                    (f) => f.uid !== e?.file?.uid
                                  )
                                );
                                setQrSetting({ ...qrSetting, logoImage: "" });
                              }}
                              // beforeUpload={(file) => {
                              //   const isLt2M = file.size / 1024 <= 1024; //less than 500 KB
                              //   if (!isLt2M) {
                              //     file.flag = true;
                              //     message.error(
                              //       "Please upload image less than 500 KB"
                              //     );
                              //     return false;
                              //   }
                              //   return true;
                              // }}
                              accept="image/*"
                            >
                              {logoImageList.length === 1 ? null : (
                                <PlusOutlined />
                              )}
                            </Upload>
                          </ImgCrop>
                        </Col>
                      </Row>
                      {qrSetting?.logoImage && (
                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col span={4}>
                            <h4>Logo Width</h4>
                          </Col>
                          <Col span={10}>
                            <Slider
                              defaultValue={qrSetting.logoWidth}
                              max={150}
                              value={qrSetting.logoWidth}
                              onChange={(e) =>
                                setQrSetting({ ...qrSetting, logoWidth: e })
                              }
                            />
                          </Col>
                        </Row>
                      )}
                      {qrSetting?.logoImage && (
                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col span={4}>
                            <h4>Logo Height</h4>
                          </Col>
                          <Col span={10}>
                            <Slider
                              defaultValue={qrSetting.logoHeight}
                              max={150}
                              value={qrSetting.logoHeight}
                              onChange={(e) =>
                                setQrSetting({ ...qrSetting, logoHeight: e })
                              }
                            />
                          </Col>
                        </Row>
                      )}
                      {qrSetting?.logoImage && (
                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col span={4}>
                            <h4>Logo Opacity</h4>
                          </Col>
                          <Col span={10}>
                            <Slider
                              defaultValue={qrSetting.logoOpacity}
                              max={1}
                              min={0}
                              step={0.1}
                              value={qrSetting.logoOpacity}
                              onChange={(e) =>
                                setQrSetting({ ...qrSetting, logoOpacity: e })
                              }
                            />
                          </Col>
                        </Row>
                      )}
                    </span>
                  </Panel>
                </Collapse>
                <Item style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    shape="round"
                    size="large"
                    htmlType="submit"
                    loading={isAdding}
                    style={{
                      paddingLeft: 30,
                      paddingRight: 30,
                      textTransform: "uppercase",
                      background: primaryDark,
                      borderColor: primaryDark,
                      fontWeight: "500",
                    }}
                  >
                    Add Wave Code
                  </Button>
                </Item>
              </Form>
            </Col>
          </Row>
        </Col>

        <Col span={8} className="subContainer">
          <Collapse
            defaultActiveKey={["1"]}
            bordered={false}
            className="site-collapse-custom-panel"
            expandIcon={({ isActive }) => (
              <DoubleRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Panel header="Preview" key={1}>
              <div
              // style={{ height: 700,  overflowY: "scroll" }}
              >
                <PreviewVcard
                  selectedTheme={0}
                  secondaryColor={colors?.secondary}
                  primaryColor={colors.primary}
                  bgImage={bgImage && bgImage?.url}
                  profileImage={profileImage && profileImage?.url}
                  fName={basicInfo.fName}
                  fNamePrefix={basicInfo.fNamePrefix}
                  lName={basicInfo.lName}
                  lNameSuffix={basicInfo.lNameSuffix}
                  mobile={basicInfo.mobile}
                  mobile2={basicInfo.mobile2}
                  phone={basicInfo.phone}
                  phone2={basicInfo.phone2}
                  email={basicInfo.email}
                  email2={basicInfo.email2}
                  jobTitle={basicInfo.jobTitle}
                  company={basicInfo.company}
                  address={basicInfo.address}
                  postalAddress={basicInfo.postalAddress}
                  link={link}
                  summary={basicInfo.summary}
                  webLinks={finalWebSites}
                  images={fileList}
                  youtubeLinks={youtubeLinks}
                  // socialLinks={socialLinks}
                  qrSetting={qrSetting}
                  showQr={showQr}
                  sectionOrder={sectionOrder}
                  setSectionOrder={setSectionOrder}
                />
              </div>
            </Panel>
            <Panel header="WaveCode" key={2}>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <QRCode
                    size={qrSetting.size}
                    value={`${
                      process.env.REACT_APP_DOMAIN_URL ||
                      "https://wavecodes.com.au"
                    }/wc/${link}`}
                    quietZone={qrSetting.quietZone}
                    fgColor={qrSetting.fgColor}
                    bgColor={qrSetting.bgColor}
                    ecLevel={qrSetting.ecLevel}
                    qrStyle={qrSetting.qrStyle}
                    eyeRadius={qrSetting.eyeRadius}
                    logoImage={qrSetting.logoImage}
                    logoWidth={qrSetting.logoWidth}
                    logoHeight={qrSetting.logoHeight}
                    logoOpacity={qrSetting.logoOpacity}
                  />

                  {/* <Button
                    block
                    size="large"
                    type="primary"
                    shape="round"
                    style={{
                      marginTop: 24,

                      background: primaryDark,
                      borderColor: primaryDark,
                      fontWeight: "500",
                    }}
                    onClick={handleDownloadQR}
                  >
                    Download Wave Code
                  </Button> */}
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </Col>
      </Row>
      <Modal
        visible={isUploadingImage}
        footer={null}
        closable={false}
        centered
        bodyStyle={{
          margin: "0 auto",
          width: 350,
          height: 350,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          className="spin-loader"
          src={loader}
          preview={false}
          draggable={false}
        />
      </Modal>
      <Modal
        visible={isRemoving}
        footer={null}
        closable={false}
        centered
        bodyStyle={{
          margin: "0 auto",
          width: 350,
          height: 350,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          className="spin-loader"
          src={loader}
          preview={false}
          draggable={false}
        />
      </Modal>
      {/* Choose Icon */}
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ paddingLeft: "2rem", paddingRight: "2rem" }}
        visible={!!iconModal}
        title="Choose Weblink Icon"
        footer={null}
        onCancel={() => setIconModal("")}
      >
        <Search
          placeholder="Search Icon"
          onSearch={() => {
            handleSearchIcon();
          }}
          value={searchIconValue}
          onChange={(e) => {
            setSearchIconValue(e.target.value);
          }}
          enterButton
        />
        <div style={{ marginTop: "1rem", padding: "1rem" }}>
          {searchedIcon?.length > 0 ? (
            <Space wrap={true}>
              {searchedIcon?.slice(0, 20).map((icon) => (
                <i
                  onClick={() => {
                    handleAddIcon(iconModal, icon);
                  }}
                  key={icon}
                  className={`fas fa-${icon} fa-2x`}
                  style={{ margin: "1rem", cursor: "pointer" }}
                />
              ))}
            </Space>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <p>
                {searchIconValue.length > 0 ? "No Icon Found" : "Search Icon"}
              </p>

              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginTop: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                OR
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <p>Upload Custom Icon</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ImgCrop
                    rotate
                    modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                    quality={1}
                    shape="rect"
                    // minZoom={1}
                    // maxZoom={10}
                    // aspect={2 / 1}
                    // modalWidth={530}
                    fillColor="#00000000"
                  >
                    <Upload
                      className="fileList-upload-images"
                      maxCount={1}
                      customRequest={(e) => {
                        handleAddCustomIcon(e, iconModal);
                      }}
                      fileList={[]}
                      listType="picture-card"
                      onPreview={handlePreview}
                      onRemove={(e) => handleImageRemove(e?.name)}
                      onChange={(e) => {}}
                      accept="image/png"
                    >
                      <PlusOutlined />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
      {/* Image Preview Modal */}
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ padding: 10 }}
        visible={previewVisible}
        title="Image Preview"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
      {/* Form Failed Modal */}
      <Modal
        title="Input Required"
        visible={isErrorModalVisible}
        footer={null}
        onCancel={() => setIsErrorModalVisible(false)}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ color: danger }}>
            Please Check and fill the mandatory fields to proceed
          </p>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
            }}
            onClick={() => setIsErrorModalVisible(false)}
          >
            Close
          </Button>
        </div>
      </Modal>

      {/* After QR Add Modal */}
      <Modal
        visible={isAddedSuccess}
        centered
        width={750}
        footer={null}
        closable={false}
      >
        <Row span={24}>
          <Col xs={24} md={12}>
            <div className="svgWrapper">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 98.5 98.5"
                enableBackground="new 0 0 98.5 98.5"
                xmlSpace="preserve"
              >
                <path
                  className="checkmark"
                  fill="none"
                  strokeWidth="8"
                  strokeMiterlimit="10"
                  d="M81.7,17.8C73.5,9.3,62,4,49.2,4
	C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                />
              </svg>
            </div>
            <h2>Saved Successfully!</h2>
            <Row className="noticeWrapper">
              <Col span={2}>
                <InfoCircleOutlined style={{ color: "#00000090" }} />
              </Col>
              <Col span={22}>
                <p>IMPORTANT</p>
                <p>
                  Please make sure to test your QR before sharing or printing.
                </p>
              </Col>
            </Row>
            <Input
              className="copyQRInput"
              value={`${
                process.env.REACT_APP_DOMAIN_URL || "https://wavecodes.com.au"
              }/wc/${link}`}
              onClick={handleCopyLink}
              suffix={
                <CopyOutlined
                  style={{ color: "#d4d4d4", fontSize: 24 }}
                  onClick={handleCopyLink}
                />
              }
            />
            <div className="previewButton">
              <Button
                size="large"
                type="dashed"
                icon={<RiExternalLinkFill style={{ marginRight: 5 }} />}
              >
                <Link target="_blank" to={`/wc/${link}`}>
                  Preview
                </Link>
              </Button>
              <Button
                size="large"
                type="primary"
                style={{ background: primaryDark, borderColor: primaryDark }}
              >
                <Link to="/">Dashboard</Link>
              </Button>
            </div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <QRCode
              size={qrSetting.size}
              value={`${
                process.env.REACT_APP_DOMAIN_URL || "https://wavecodes.com.au"
              }/wc/${link}`}
              quietZone={qrSetting.quietZone}
              fgColor={qrSetting.fgColor}
              bgColor={qrSetting.bgColor}
              ecLevel={qrSetting.ecLevel}
              qrStyle={qrSetting.qrStyle}
              eyeRadius={qrSetting.eyeRadius}
              logoImage={qrSetting.logoImage}
              logoWidth={qrSetting.logoWidth}
              logoHeight={qrSetting.logoHeight}
              logoOpacity={qrSetting.logoOpacity}
            />
            <Button
              // block
              size="large"
              type="primary"
              shape="round"
              style={{
                marginTop: 24,

                background: primaryDark,
                borderColor: primaryDark,
                fontWeight: "500",
              }}
              onClick={handleDownloadQR}
            >
              Download Wave Code
            </Button>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default GenerateQRCode;
